"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStoreHours = void 0;

var _luxon = require("luxon");

var _const = require("./const");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var formatTime = function formatTime(time) {
  return _luxon.DateTime.fromFormat(time.slice(0, 8).split('-')[0], 'hh:mm:ss', {
    locale: 'en-US'
  }).toLocaleString(_luxon.DateTime.TIME_SIMPLE);
};

var getTime = function getTime(_ref) {
  var open = _ref.open,
      close = _ref.close;
  return "".concat(formatTime(open), " - ").concat(formatTime(close));
}; // TODO: merge to single reduce;


var getRegularTimeTable = function getRegularTimeTable(regular) {
  var timeTable = _const.fullWeek.reduce(function (acc, wDay) {
    var closedDay = {
      day: wDay,
      open: 0,
      close: 0
    };

    var _ref2 = regular.find(function (_ref3) {
      var day = _ref3.day;
      return day === wDay;
    }) || closedDay,
        open = _ref2.open,
        close = _ref2.close,
        day = _ref2.day;

    var currentTime = open && close && getTime({
      open: open,
      close: close
    }); // @ts-ignore

    acc = _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, currentTime || day, [].concat(_toConsumableArray(acc[currentTime] || []), [day])));
    return acc;
  }, {});

  return Object.keys(timeTable).reduce(function (acc, key) {
    var label = ''; // @ts-ignore

    var isSingleDay = timeTable[key].length === 1; // @ts-ignore

    timeTable[key].map(function (day, index) {
      var plannedNextDay = _const.fullWeek[_const.fullWeek.indexOf(day) + 1]; // @ts-ignore


      var nextDay = timeTable[key][index + 1];
      label = "".concat(label).concat(day.slice(0, isSingleDay ? 3 : 1)).concat(nextDay ? plannedNextDay === nextDay ? ' - ' : ', ' : '');
    });
    var isClosedDay = key.includes(label);
    acc = _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, label.replace(/-[^,]*-/, '-'), !isClosedDay && key.toLowerCase()));
    return acc;
  }, {});
};

var getClosedWeekdays = function getClosedWeekdays(regular) {
  return _const.weekdays.reduce(function (acc, weekDay) {
    if (!regular.some(function (_ref4) {
      var day = _ref4.day;
      return day === weekDay;
    })) {
      acc = [].concat(_toConsumableArray(acc), [weekDay.slice(0, 2)]);
    }

    return acc;
  }, []);
}; // @ts-ignore


var getHolidays = function getHolidays(_ref5) {
  var override = _ref5.override,
      regular = _ref5.regular;

  // @ts-ignore
  var getOpenedTime = function getOpenedTime(_ref6) {
    var weekDay = _ref6.weekDay;
    // @ts-ignore
    var regularDay = regular.find(function (_ref7) {
      var day = _ref7.day;
      return day === weekDay;
    });
    return regularDay && formatTime(regularDay.open);
  };

  var holidays = []; // @ts-ignore

  override.map(function (_ref8) {
    var date = _ref8.date,
        name = _ref8.name,
        start = _ref8.start,
        end = _ref8.end;

    var daysToHoliday = _luxon.DateTime.fromISO(date).diff(_luxon.DateTime.now(), 'days').days;

    if (daysToHoliday >= 0 && daysToHoliday < _const.HOLIDAYS_DAYS_RANGE) {
      var holidayRange = _luxon.DateTime.fromISO(end).diff(_luxon.DateTime.fromISO(start), 'days').days;

      var holidayDate = _luxon.DateTime.fromISO(date).toFormat('LLLL dd');

      var holidayName = name.split('-')[0].trim();
      var storeOpenedTime = getOpenedTime({
        weekDay: _luxon.DateTime.fromISO(date).toFormat('cccc')
      });

      var storeClosedTime = _luxon.DateTime.fromISO(start, {
        locale: 'en-US'
      }).toUTC().toFormat('t');

      holidays = [].concat(_toConsumableArray(holidays), [{
        date: date,
        label: "".concat(holidayName, ", ").concat(holidayDate),
        timetable: "".concat(storeOpenedTime && storeClosedTime && holidayRange !== 1 ? "".concat(storeOpenedTime, " - ").concat(storeClosedTime).toLowerCase() : 'closed')
      }]);
    }
  });
  return holidays.sort(function (_ref9, _ref10) {
    var a = _ref9.date;
    var b = _ref10.date;
    return _luxon.DateTime.fromISO(a).toMillis() - _luxon.DateTime.fromISO(b).toMillis();
  });
};

var useStoreHours = function useStoreHours(_ref11) {
  var _ref11$hours = _ref11.hours,
      regular = _ref11$hours.regular,
      override = _ref11$hours.override;
  var timeTable = regular ? getRegularTimeTable(regular) : {};
  var closedDays = regular ? getClosedWeekdays(regular) : [];
  var holidays = override && regular ? getHolidays({
    override: override,
    regular: regular
  }) : [];
  return {
    timeTable: timeTable,
    closedDays: closedDays,
    holidays: holidays
  };
};

exports.useStoreHours = useStoreHours;